var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveTips2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8896 133.333L62.8791 133.327L62.8686 133.322L16.1363 108.592C16.1361 108.591 16.1358 108.591 16.1355 108.591C11.7424 106.265 9 101.709 9 96.8367L9 42.0475C9 37.139 11.7238 32.627 16.1993 30.2324C16.2021 30.2308 16.205 30.2293 16.2079 30.2278L62.8459 5.63242C62.8493 5.63063 62.8528 5.62886 62.8562 5.62709C67.0282 3.4577 71.9715 3.45764 76.1436 5.62694C76.1471 5.62875 76.1506 5.63058 76.1541 5.63242L122.811 30.2377L122.82 30.2425C127.257 32.5678 130 37.1154 130 42.0475V96.8367C130 101.759 127.264 106.262 122.864 108.592L122.863 108.592L76.1882 133.323L76.1623 133.336L76.1366 133.35C74.1241 134.455 71.8605 135 69.5586 135C67.2635 135 64.9848 134.457 62.8896 133.333Z",
    stroke: "url(#paint0_linear_7646_768)",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.545 123C67.295 123 65.045 122.465 62.975 121.35L27.11 102.313C22.745 99.995 20 95.4475 20 90.5433V48.3675C20 43.4187 22.745 38.9158 27.155 36.5529L62.975 17.605C67.07 15.465 71.93 15.465 76.025 17.605L111.845 36.5529C116.255 38.8712 119 43.4187 119 48.3675V90.5433C119 95.4921 116.255 99.995 111.89 102.313L76.07 121.35C74.045 122.465 71.795 123 69.545 123Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.545 123C67.295 123 65.045 122.465 62.975 121.35L27.11 102.313C22.745 99.995 20 95.4475 20 90.5433V48.3675C20 43.4187 22.745 38.9158 27.155 36.5529L62.975 17.605C67.07 15.465 71.93 15.465 76.025 17.605L111.845 36.5529C116.255 38.8712 119 43.4187 119 48.3675V90.5433C119 95.4921 116.255 99.995 111.89 102.313L76.07 121.35C74.045 122.465 71.795 123 69.545 123Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.545 123C67.295 123 65.045 122.465 62.975 121.35L27.11 102.313C22.745 99.995 20 95.4475 20 90.5433V48.3675C20 43.4187 22.745 38.9158 27.155 36.5529L62.975 17.605C67.07 15.465 71.93 15.465 76.025 17.605L111.845 36.5529C116.255 38.8712 119 43.4187 119 48.3675V90.5433C119 95.4921 116.255 99.995 111.89 102.313L76.07 121.35C74.045 122.465 71.795 123 69.545 123Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.545 123C67.295 123 65.045 122.465 62.975 121.35L27.11 102.313C22.745 99.995 20 95.4475 20 90.5433V48.3675C20 43.4187 22.745 38.9158 27.155 36.5529L62.975 17.605C67.07 15.465 71.93 15.465 76.025 17.605L111.845 36.5529C116.255 38.8712 119 43.4187 119 48.3675V90.5433C119 95.4921 116.255 99.995 111.89 102.313L76.07 121.35C74.045 122.465 71.795 123 69.545 123Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.541 96V84.758L67.715 69.358C72.72 65.431 74.645 62.89 74.645 59.656C74.645 56.268 72.258 54.189 68.639 54.189C65.02 54.189 62.171 56.268 57.936 61.119L47.849 52.726C53.624 45.257 59.322 41.176 69.794 41.176C81.575 41.176 89.66 48.183 89.66 58.347V58.501C89.66 67.125 85.194 71.591 77.186 77.366L67.946 83.834H90.199V96H47.541Z",
    fill: "#4F4F4F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7646_768",
    x1: 21.9737,
    y1: 122.452,
    x2: 121.065,
    y2: 14.0335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveTips2);
export default __webpack_public_path__ + "static/media/live-tips-2.280ae5087a57863e113a8fd8b329a818.svg";
export { ForwardRef as ReactComponent };